module.exports = {
  DEPARTEMENT: "departement",
  JOBTYPE: "jobtype",
  JOBTITLE: "jobtitle",
  PUBLISHEDD: "published",
  ADMIN: "ZA",
  SP: "SP",
  REMOTE: "Fully_remote",
};
